import { render } from "./App.vue?vue&type=template&id=cf0f120c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=cf0f120c&lang=scss"
script.render = render

export default script